const handler = ( $ ) => {
	const $switchers = $( '.header__lang-switcher' );
	if ( ! $switchers.length ) return;

	const closeAll = () => {
		$switchers.removeClass( 'is-open' );
		$switchers
			.find( '.header__utility-link--language' )
			.attr( 'aria-expanded', 'false' );
	};

	const markCurrent = ( $menu, $link ) => {
		$menu.find( 'li' ).removeClass( 'is-current' );
		$menu.find( 'a[aria-current="true"]' ).removeAttr( 'aria-current' );

		$link.attr( 'aria-current', 'true' );
		$link.closest( 'li' ).addClass( 'is-current' );
	};

	const triggerGTranslate = ( $link ) => {
		const href = ( $link.attr( 'href' ) || '' ).trim();
		const lang = (
			$link.attr( 'data-gt-lang' ) ||
			$link.data( 'gt-lang' ) ||
			''
		)
			.toString()
			.trim();

		if ( lang ) {
			const $select = $( 'select.goog-te-combo' ).first();
			if ( $select.length ) {
				$select.val( lang ).trigger( 'change' );
				return true;
			}
			if ( window.__gt_translate ) {
				try {
					window.__gt_translate( lang );
					return true;
				} catch ( e ) {}
			}
		}

		if ( href && href !== '#' ) {
			window.location.href = href;
			return true;
		}

		return false;
	};

	$switchers.each( function () {
		const $switcher = $( this );
		const $toggle = $switcher
			.find( '.header__utility-link--language' )
			.first();
		const $menu = $switcher.find( '.header__lang-menu' ).first();
		const $label = $toggle.find( '.header__utility-text' ).first();

		if ( ! $toggle.length || ! $menu.length || ! $label.length ) return;

		$toggle.attr( { 'aria-haspopup': 'true', 'aria-expanded': 'false' } );

		// Collect available lang codes from the menu to validate candidates against.
		const availableLangs = $menu
			.find( 'a[data-gt-lang]' )
			.map( function () {
				return $( this ).attr( 'data-gt-lang' );
			} )
			.get();

		// URL path is the most authoritative source on Pantheon: /so/ → 'so'.
		// It is always accurate regardless of caching or session state.
		const pathLang = ( () => {
			const parts = window.location.pathname
				.split( '/' )
				.filter( Boolean );
			if ( ! parts.length ) return '';
			const candidate = parts[ 0 ].toLowerCase();
			return (
				availableLangs.find(
					( l ) => l.toLowerCase() === candidate
				) || ''
			);
		} )();

		// Cookie is user-specific and survives Pantheon's page cache.
		const cookieLang = ( () => {
			const match = document.cookie.match(
				/(?:^|;\s*)googtrans=([^;]*)/
			);
			if ( ! match ) return '';
			const parts = decodeURIComponent( match[ 1 ] )
				.split( '/' )
				.filter( Boolean );
			return parts.length >= 2 ? parts[ parts.length - 1 ] : '';
		} )();

		const currentCode = (
			pathLang ||
			cookieLang ||
			$switcher.attr( 'data-current-lang' ) ||
			''
		).trim();
		if ( currentCode ) {
			const $current = $menu
				.find( `a[data-gt-lang="${ currentCode }"]` )
				.first();
			if ( $current.length ) {
				markCurrent( $menu, $current );
				const text = $current
					.find( '.header__lang-menu-text' )
					.text()
					.trim();
				if ( text ) $label.text( text );
			}
		}

		$toggle.on( 'click', function ( e ) {
			e.preventDefault();
			const isOpen = $switcher.hasClass( 'is-open' );
			closeAll();
			if ( ! isOpen ) {
				$switcher.addClass( 'is-open' );
				$toggle.attr( 'aria-expanded', 'true' );
			}
		} );

		$menu.on( 'click', 'a.header__lang-menu-link', function ( e ) {
			e.preventDefault();

			const $link = $( this );

			const newText =
				$link.find( '.header__lang-menu-text' ).text().trim() ||
				$link.text().trim();

			if ( newText ) {
				$label.text( newText );
			}

			markCurrent( $menu, $link );

			$switcher.removeClass( 'is-open' );
			$toggle.attr( 'aria-expanded', 'false' );

			triggerGTranslate( $link );
		} );

		$menu.on( 'wheel', function ( e ) {
			const el = this;
			const originalEvent = e.originalEvent;
			const delta = originalEvent.deltaY;
			const { scrollTop, scrollHeight, clientHeight } = el;

			const atTop = scrollTop <= 0;
			const atBottom = scrollTop + clientHeight >= scrollHeight - 1;

			if ( ( delta < 0 && atTop ) || ( delta > 0 && atBottom ) ) {
				e.preventDefault();
			}
		} );
	} );

	$( document ).on( 'click.headerLang', function ( e ) {
		if ( $( e.target ).closest( '.header__lang-switcher' ).length ) return;
		closeAll();
	} );

	$( document ).on( 'keyup.headerLang', function ( e ) {
		if ( e.key === 'Escape' ) closeAll();
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
